import React from 'react';
import Gallery from './MainPages/Gallery';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './Components/Header';

// Pages




// Pages Ends


function App() {
  return (
    <Router>
      <Header />
      <Routes>  {/* Use Routes if your React Router version is v6 or later */}
        <Route path="/" element={<Gallery />} />
        <Route path="/gallery" element={<Gallery />} />


      </Routes>
    </Router>
  );
}

export default App;
